import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui.min';

class Accordion {
    constructor() {
        this.accordionContainers = document.querySelectorAll('.js-accordion-container');
        if (this.accordionContainers.length) {
            this.accordionContainers.forEach((accordionContainer) => {
                this.bindContainer(accordionContainer);
            });
        }

        this.accordions = document.querySelectorAll('.js-accordion');
        if (this.accordions.length) {
            this.accordions.forEach((accordion) => {
                Accordion.bind(accordion);
            });
        }
    }

    bindContainer(container) {
        container.querySelector('.js-accordion-container-trigger').addEventListener('click', () => {
            const contentClass = '.js-accordion-container-content';
            this.accordionContainers.forEach((other) => {
                if (other !== container) {
                    other.classList.remove('active');
                    Accordion.applyVelocity(other, contentClass);
                }
            });
            const isActive = container.classList.contains('active');
            if (!isActive) {
                container.classList.add('active');
                Accordion.applyVelocity(container, contentClass, true);
            } else {
                container.classList.remove('active');
                Accordion.applyVelocity(container, contentClass);
            }
        });
    }

    static bind(accordion) {
        const items = accordion.querySelectorAll('.js-accordion-item');
        const contentClass = '.js-accordion-content';

        items.forEach((item) => {
            item.querySelector('.js-accordion-trigger').addEventListener('click', () => {
                const active = accordion.querySelector('.js-accordion-item.active');
                if (active) {
                    Accordion.applyVelocity(active, contentClass);
                }

                const isActive = item.classList.contains('active');

                items.forEach((otherItem) => {
                    otherItem.classList.remove('active');
                });

                if (!isActive) {
                    item.classList.add('active');
                    Accordion.applyVelocity(item, contentClass, true);
                }
            });
        });
    }

    static applyVelocity(haystack, toSelect, isDown = false) {
        const target = haystack.querySelector(toSelect);
        const way = isDown ? 'slideDown' : 'slideUp';
        if (target) {
            Velocity(
                target,
                way,
                { duration: 200, easing: 'easeInOutQuad', complete: () => {} },
            );
        }
    }
}

export default Accordion;
